/**
 * Article main class for FAQ
 */
import { BaseAPI } from '../BaseAPI'

class ArticleClass extends BaseAPI {

  /**
   *  @method: getList method to get the article list
   *  @params: search params in object
   *  @output: List of articles data 
   */

  getList = (searchParams) => {
    let postBody = { ...searchParams, perpage: searchParams.perpage, page: searchParams.page }
    return this.postData(`${this.baseURL}/troublesht/v1/article/list`, postBody);
  }

  /**
   *  @method: getDetailById method to get the article detail by Id
   *  @params: articleId
   *  @output: article content data 
   */
  getDetailById = (articleId) => {
    return this.postData(`${this.baseURL}/troublesht/v1/article/detail`, {articleID: articleId});
  }


  /**
 * @method: saveFeedback to save feedback
 * @param: object
 * @returns: status in object
 */

  saveFeedback = (fbRequestData) => {
    return this.postData(`${this.baseURL}/troublesht/v1/article/feedback`, fbRequestData);
  }


  /**
   * @method: SaveAccessFootPrint to save Access Footpring log
   * @param: Object
   * @returns: Status in object 
   */
  SaveAccessFootPrint = (reqData) => {
    return this.postData(`${this.baseURL}/troublesht/v1/article/accesslog`, reqData);
  }

  /**
   * @method: UpdateAccessFootPrint to update article reading time
   * @param: Object
   * @returns: Status in object 
   */
  UpdateAccessFootPrint = (reqData) => {
    return this.postData(`${this.baseURL}/troublesht/v1/article/accesslog`, reqData);
  }


  
}

export { ArticleClass }
